import { getCurrentCustomerId, getCurrentSiteId } from "../route/routes";
import { getCurrentSiteState, getRouterState } from "../rootReducer";
import {
  putCurrentSiteData,
  putCurrentSiteError,
  putCurrentSitePending,
} from "./reducer";
import { error as logError } from "../logger/actions";
import { EVENT_ERROR_OCCURED } from "../logger/constants";
import { fetchSite } from "../../../apiFacades/csu/site";
import { ReduxDispatch, ReduxGetState } from "../../../typings";

export const fetchCurrentSite = (customerId: string, siteId: string) => async (
  dispatch: ReduxDispatch,
) => {
  try {
    // setting pending status
    dispatch(putCurrentSitePending());
    // fetching site
    const site = await dispatch(fetchSite(customerId, siteId));
    // putting site data to store
    dispatch(putCurrentSiteData(site));
  } catch (errorResp) {
    try {
      const { code, message } = errorResp.payload.error;
      dispatch(
        logError(EVENT_ERROR_OCCURED, null, `${code ? code : ""} ${message}`),
      );
      return dispatch(putCurrentSiteError(message, code));
    } catch (err) {
      const errorMessage = `Can't parse csu-api response, Original error: ${errorResp}`;
      dispatch(logError(EVENT_ERROR_OCCURED, null, errorMessage));
      return dispatch(putCurrentSiteError(errorMessage));
    }
  }
};

export const ensureCurrentSite = (customerId: string, siteId: string) => async (
  dispatch: ReduxDispatch,
  getState: ReduxGetState,
) => {
  const { data } = getCurrentSiteState(getState());
  if (!data) {
    return dispatch(fetchCurrentSite(customerId, siteId));
  }
  const routerState = getRouterState(getState());
  const currentCustomerId = getCurrentCustomerId(routerState);
  const currentSiteId = getCurrentSiteId(routerState);

  if (data.id === currentSiteId && customerId === currentCustomerId) {
    return;
  }
  dispatch(fetchCurrentSite(customerId, siteId));
};
